import queryString from 'query-string';
import {Map} from 'immutable';
import {LOCATION_REPLACE, LOCATION_UPDATE} from '../actions';

export function location(state = null, action) {
  let nextState = state || Map({
    pathname: window.location.pathname,
    query: queryString.parse(window.location.search),
  });

  if (~[LOCATION_REPLACE, LOCATION_UPDATE].indexOf(action.type)) {
    nextState = nextState
      .set('pathname', (action.pathname || nextState.get('pathname')))
      .set('query', (action.query || nextState.get('query')));
  }

  return nextState;
}



// WEBPACK FOOTER //
// ./app/javascript/reducers/location.js